module.exports = __webpack_public_path__ + "img/reset.8444d799.svg";